/** @format */

import React from 'react';
import { UpdatePasswordContainer } from 'features/auth';

const UpdatePasswordPage: React.FC = () => {
  return <UpdatePasswordContainer />;
};

export default UpdatePasswordPage;
